import React from "react";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation("translation", { keyPrefix: "error.404" });

  return (
    <div className="notfound">
      <div className="notfound__container">
        <img src="/assets/img/YemekPos_LOGO.png" alt="YemekPos Logo" className="notfound__logo" />
        <h1 className="notfound__code">{t("notFoundCode")}</h1>
        <h2 className="notfound__title">{t("heading")}</h2>
        <p className="notfound__message">{t("message")}</p>
        <a href="https://www.yemekpos.com/" className="notfound__button">
          {t("actions.home")}
        </a>
      </div>
    </div>
  );
}
